import { adminPath } from '@/core/utils/env.utils';

export const GRAPH_ENDPOINTS = {
  KEYS: adminPath('/graphs/keys'),
  UPLOAD: (graphKey: string) => adminPath(`/graphs/${graphKey}`),
} as const;
